import axios from 'axios'
import ApplicationController from '../application_controller.js'
import { isBlank } from '../../commons.js'
import State from './state.js'

export default class InvoicePaymentsController extends ApplicationController {

  static targets = [
    "submitButton"
  ]

  edit(e) {
    e.preventDefault()

    if (!State.editor_opened) {
      axios.get(e.target.getAttribute('href')).then(response => {
        this.element.outerHTML = response.data
        State.editor_opened = true
      })
    }
  }

  submit(e) {
    e.preventDefault()

    this.submitButtonTarget.disabled = true

    var form = e.target.closest('form')
    axios({
      method: form.getAttribute('method'),
      url: form.getAttribute('action'),
      data: new FormData(form)
    }).then(response => {
      this.reload_page()
    }).catch(error => {
      this.alert(error.response.data)
    })
    State.editor_opened = false
  }

  cancel(e) {
    e.preventDefault()

    if (isBlank(this.element.dataset.id)) {
      this.element.innerHTML = ''
    } else {
      axios.get(e.target.getAttribute('href')).then(response => {
        this.element.outerHTML = response.data
      })
    }
    State.editor_opened = false
  }

  destroy(e) {
    e.preventDefault()
    this.confirm(e.target.dataset.confirmText, reason => {
      if (reason.confirm) {
        axios.delete(e.target.getAttribute('href')).then(() => {
          this.reload_page()
        })
      }
      reason.close_modal()
    })
  }


}